import logo from './main-logo.png'

export const IMAGES = {
  logo,
}
